import React from 'react'
import IconWrapper from './IconWrapper'

export const CommentIcon = props => (
    <IconWrapper {...props}>
        <svg
            className="icon-comment"
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            fill="none"
            strokeWidth="1.5"
            color="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12c0 1.821.487 3.53 1.338 5L2.5 21.5l4.5-.838A9.955 9.955 0 0012 22z"
            ></path>
        </svg>
    </IconWrapper>
)
